import React from 'react';
import { Button, Progress, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ProgressModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			progress: 0,
			disabled: true,
			onClose: null
		};

		this.hide = this.hide.bind(this);
	}

	setProgress(value) {
		if (value === 100)
			this.setState({
				progress: value,
				disabled: false
			});
		else
			this.setState({
				progress: value,
				disabled: true
			});
	}

	show(obj) {
		this.setState({
			modal: true,
			disabled: true,
			onClose: obj.onClose
		});
	}

	hide(value) {
		this.setState({
			modal: false,
		})
		this.state.onClose();
		setTimeout(() => {
			this.setProgress(0);
		}, 500);

	}

	render() {
		return (
			<div>
				<Modal isOpen={this.state.modal} keyboard={false} backdrop="static" toggle={this.hide} className={this.props.className}>
					<ModalHeader>Envoi en cours</ModalHeader>
					<ModalBody>
						<div className={(!this.state.disabled)?"text-muted":""}>
							Veuillez patienter pendant l'envoi de vos informations. Vous pourrez quitter cette fenêtre dès que le transfert sera fini.
						</div>
						{ !this.state.disabled && <div>
							<strong>Envoi terminé, vous pouvez maintenant fermer cette fenêtre.</strong>
						</div> }
						<div className="text-center">{this.state.progress}%</div>
						<Progress value={this.state.progress} />
					</ModalBody>
					<ModalFooter>
						<Button color="primary" disabled={this.state.disabled} onClick={this.hide}>Fermer</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}


export default ProgressModal;



// WEBPACK FOOTER //
// ./src/modals/ProgressModal.jsx